import Vue from 'vue'
import Vuex from 'vuex'
// import feathers from '@/feathers/'
import uniqid from 'uniqid'
import entities from './entities'
// import distance from '@turf/distance'
import debounce from 'lodash.debounce'

import SERVER_URL from '@/config'
// import { stat } from 'fs';

import feathersClient from '../feathers'

const operationsList = [
  'update',
  'add photo',
  'remove photo',
  'toggle bad photo',
  'add pdf',
  'remove pdf',
  'toggle bad pdf',
  'add excel',
  'remove excel',
  'toggle bad excel'
]

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    entities
  },
  state: {
    online: 'on',
    windowEvents: false,
    light: ![null, 'false'].includes(localStorage.getItem('light')),
    uploadBar: ![null, 'false'].includes(localStorage.getItem('uploadBar')),
    autoRefresh: ![null, 'false'].includes(localStorage.getItem('autoRefresh')),
    searchVisible: ![null, 'false'].includes(localStorage.getItem('searchVisible')),
    loading: false,
    serverURL: SERVER_URL,
    feathers: feathersClient,
    auth: {
      user: null,
      token: null
    },
    log: {
      limit: 10,
      page: 1,
      open: false,
      items: [],
      filter: 'toate'
    },
    posInterval: null,
    services: {
      users: feathersClient.service('users'),
      xlsx: feathersClient.service('xlsx'),
      entities: feathersClient.service('entities'),
      photos: feathersClient.service('photos'),
      pdfs: feathersClient.service('pdfs'),
      excels: feathersClient.service('excels'),
      'upload-test': feathersClient.service('upload-test'),
      adminrequests: feathersClient.service('adminrequests'),
      diff: feathersClient.service('diff'),
      locations: feathersClient.service('locations'),
      reminders: feathersClient.service('reminders')
    },
    info: {},
    stats: {
      users: []
    },
    mapCenter: JSON.parse(localStorage.getItem('mapCenter')) || {
      lat: 44.443296,
      lng: 26.096505
    },
    zoom: Number(localStorage.getItem('zoom')) || 17,
    mapType: localStorage.getItem('mapType') || 'satellite',
    zoomDetailsPage: Number(localStorage.getItem('zoomDetailsPage')) || 17,
    mapTypeDetailsPage: localStorage.getItem('mapTypeDetailsPage') || 'satellite',
    settingsDetailsPage: localStorage.getItem('settingsDetailsPage') || [
      'repozare',
      'info obiectiv',
      'coordonate obiectiv',
      'poze obiectiv',
      'excel obiectiv',
      'pdf obiectiv',
      'info lift'
    ],

    messages: [],
    messagesOpen: false,
    isDetailsEdited: false,
    refreshCount: 0,

    users: [],
    usersLocations: [],
    adminRequestsData: null,

    expandedPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: 'createdAt'
    },
    expandedDataTotal: 0,

    tab: localStorage.getItem('tab') || 'photos',
    paneVertical: Number(localStorage.getItem('paneVertical')) || 20,
    paneHorizontal: Number(localStorage.getItem('paneHorizontal')) || 50,

    showGallery: localStorage.getItem('showGallery') !== 'false',
    showPreview: localStorage.getItem('showPreview') !== 'false',
    showEdit: localStorage.getItem('showEdit') !== 'false',

    entityDisplayMode: localStorage.getItem('entityDisplayMode') || 'gallery',

    sortList: [
      'id_scara',
      'adresa',
      'repozare',
      'repozare_text',
      'repozare_data',
      'repozare_done',
      'repozare_check',
      'reabilitat',
      'observatii_scara',
      'observatii',
      'user',
      'done',
      'checkedCoords',
      'eticheta',
      'zona',
      'addedBy',
      'nr_lift_scara',
      'createdAt',
      'updatedAt'
    ],

    diff: [],
    diffEntity: null,
    diffUser: decodeLocalStorage('diffUser') || [],
    diffOperations: decodeLocalStorage('diffOperations') || operationsList,
    diffTotal: 0,
    diffPagination: {
      rowsPerPage: 10,
      page: 1
    },
    networkBusy: false,

    watchingPosition: false,
    watchId: null,
    gettingPosition: false,
    wannaWatchPosition: !!(localStorage.getItem('wannaWatchPosition') && localStorage.getItem('wannaWatchPosition') !== 'false'),
    reminders: []
  },
  getters: {
    user: state => state.auth.user,
    token: state => state.auth.token,
    info: state => state.info,
    stats: state => state.stats,
    loading: state => state.loading,
    serverURL: state => state.serverURL,
    light: state => state.light,
    uploadBar: state => state.uploadBar,
    autoRefresh: state => state.autoRefresh,
    searchVisible: state => state.searchVisible,
    online: state => state.online,
    mapCenter: state => state.mapCenter,
    currentPosition: state => {
      const pos = state.auth.user ? state.auth.user.currentPosition : null
      if (pos && pos.lat && pos.lng) return pos
      return {
        lat: 44.443296,
        lng: 26.096505
      }
    },
    zoom: state => state.zoom,
    mapType: state => state.mapType,
    zoomDetailsPage: state => state.zoomDetailsPage,
    mapTypeDetailsPage: state => state.mapTypeDetailsPage,
    settingsDetailsPage: state => state.settingsDetailsPage,
    messages: state => state.messages,
    messagesOpen: state => state.messagesOpen,
    isDetailsEdited: state => state.isDetailsEdited,
    refreshCount: state => state.refreshCount,

    users: state => state.users,
    usernames: state => state.users ? state.users.map(u => u.username) : [],
    usersLocations: state => state.usersLocations,

    adminRequestsData: state => state.adminRequestsData,

    expandedPagination: state => state.expandedPagination,
    expandedDataTotal: state => state.expandedDataTotal,

    tab: state => state.tab,
    paneVertical: state => state.paneVertical,
    paneHorizontal: state => state.paneHorizontal,

    showGallery: state => state.showGallery,
    showPreview: state => state.showPreview,
    showEdit: state => state.showEdit,
    entityDisplayMode: state => state.entityDisplayMode,

    onColor: state => state.light ? 'primary' : 'primary lighten-2',
    offColor: state => state.light ? 'blue-grey' : 'grey lighten-2',

    sortList: state => state.sortList,

    diff: state => state.diff,
    diffTotal: state => state.diffToatal,
    diffPagination: state => state.diffPagination,
    diffEntity: state => state.diffEntity,
    diffUser: state => state.diffUser,
    diffOperations: state => state.diffOperations,
    operationsList: () => operationsList,
    networkBusy: state => state.networkBusy,

    watchingPosition: state => state.watchingPosition,
    gettingPosition: state => state.gettingPosition,
    wannaWatchPosition: state => state.wannaWatchPosition,
    reminders: state => state.reminders
  },
  mutations: {
    setLight (state, payload) {
      state.light = payload
      localStorage.setItem('light', payload)
    },
    setUploadBar (state, payload) {
      state.uploadBar = payload
      localStorage.setItem('uploadBar', payload)
    },
    setAutoRefresh (state, payload) {
      state.autoRefresh = payload
      localStorage.setItem('autoRefresh', payload)
    },
    setSearchVisible (state, payload) {
      state.searchVisible = payload
      localStorage.setItem('searchVisible', payload)
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setToken (state, payload) {
      Vue.set(state.auth, 'token', payload)
    },
    setUser (state, payload) {
      Vue.set(state.auth, 'user', payload)
    },
    addMessage (state, payload) {
      state.log.items.splice(0, 0, payload)
    },
    resetLog (state) {
      state.log.items.splice(0)
    },
    setOnline (state, payload) {
      state.online = payload
    },
    setWindowEventsState (state, payload) {
      state.windowEvents = payload
    },
    setCurrentPosition (state, payload) {
      if (state.auth && state.auth.user) {
        Vue.set(state.auth.user, 'currentPosition', payload)
      }
    },
    setInfo (state, payload) {
      Vue.set(state, 'info', payload)
    },
    setStats (state, payload) {
      Vue.set(state, 'stats', payload)
    },
    setMapCenter (state, payload) {
      state.mapCenter = payload
      localStorage.setItem('mapCenter', JSON.stringify(payload))
    },
    setZoom (state, payload) {
      state.zoom = payload
      localStorage.setItem('zoom', payload)
    },
    setMapType (state, payload) {
      state.mapType = payload
      localStorage.setItem('mapType', payload)
    },
    setZoomDetailsPage (state, payload) {
      state.zoomDetailsPage = payload
      localStorage.setItem('zoomDetailsPage', payload)
    },
    setMapTypeDetailsPage (state, payload) {
      state.mapTypeDetailsPage = payload
      localStorage.setItem('mapTypeDetailsPage', payload)
    },
    setSettingsDetailsPage (state, payload) {
      state.settingsDetailsPage = payload
      localStorage.setItem('settingsDetailsPage', payload)
    },
    saveMessage (state, payload) {
      state.messages.unshift(payload)
      state.messages = state.messages.slice(0, 20)
    },
    deleteMessage (state, payload) {
      const index = state.messages.findIndex(m => m.id === payload)
      if (index > -1) state.messages.splice(index, 1)
    },
    deleteAllMessages (state, payload) {
      state.messages = []
    },
    setMessagesOpen (state, payload) {
      if ((state.messagesOpen && !payload) || (!state.messagesOpen && payload)) {
        state.messagesOpen = payload
      }
    },
    setIsDetailsEdited (state, payload) {
      state.isDetailsEdited = payload
    },
    incrementRefreshCount (state, payload) {
      if (!state.refreshCount) {
        state.refreshCount = 1
      } else {
        state.refreshCount++
      }
    },
    resetRefreshCount (state, payload) {
      state.refreshCount = 0
    },
    setUsers (state, payload) {
      state.users = payload
    },
    setUsersLocations (state, payload) {
      state.usersLocations = payload.filter(user => user.currentPosition).map(user => ({
        id: user._id,
        username: user.username,
        position: user.currentPosition
      }))
    },
    setAdminRequestsData (state, payload) {
      state.adminRequestsData = payload
      state.expandedDataTotal = payload.total
    },
    clearAdminRequestsData (state) {
      state.adminRequestsData = null
    },
    setExpandedPagination (state, payload) { // only sets page, other fields are irrelevant
      Vue.set(state.expandedPagination, 'page', payload.page)
    },

    setDashboardTab (state, payload) {
      state.tab = payload
      localStorage.setItem('tab', payload)
    },
    setDashboardSplitPane (state, payload) {
      if (payload.dir === 'horizontal') {
        state.paneHorizontal = payload.val
        localStorage.setItem('paneHorizontal', payload.val)
      } else {
        state.paneVertical = payload.val
        localStorage.setItem('paneVertical', payload.val)
      }
    },

    setGalleryVisibility (state, payload) {
      state.showGallery = payload
      localStorage.setItem('showGallery', payload)
    },
    setPreviewVisibility (state, payload) {
      state.showPreview = payload
      localStorage.setItem('showPreview', payload)
    },
    setEditVisibility (state, payload) {
      state.showEdit = payload

      localStorage.setItem('showEdit', payload)
    },

    setDiff (state, payload) {
      state.diff = payload.data
      state.diffTotal = payload.total
    },
    setDiffPagination (state, payload) {
      state.diffPagination = payload
    },
    setDiffEntity (state, payload) {
      state.diffEntity = payload
    },
    setDiffUser (state, payload) {
      state.diffUser = payload
      localStorage.setItem('diffUser', payload)
    },
    setDiffOperations (state, payload) {
      state.diffOperations = payload
      localStorage.setItem('diffOperations', payload)
    },
    setNetworkBusy (state, payload) {
      state.networkBusy = payload
    },
    setEntityDisplayMode (state, payload) {
      state.entityDisplayMode = payload
      localStorage.setItem('entityDisplayMode', payload)
    },

    setWatchingPosition (state, payload) {
      state.watchingPosition = payload
    },
    setWatchId (state, payload) {
      state.watchId = payload
    },
    setGettingPosition (state, payload) {
      state.gettingPosition = payload
    },
    setWannaWatchPosition (state, payload) {
      state.wannaWatchPosition = payload
      localStorage.setItem('wannaWatchPosition', payload)
    },
    setReminders (state, payload) {
      state.reminders = payload
    }
  },
  actions: {
    async login ({ state, commit, dispatch }, data) {
      commit('setNetworkBusy', true)

      if (data) {
        try {
          await dispatch('logout')
          const auth = await state.feathers.authenticate({
            strategy: 'local',
            email: data.email,
            password: data.password
          })
          const user = auth.user
          const token = auth.accessToken

          await state.feathers.passport.verifyJWT(auth.accessToken)

          dispatch('setEventWatchers')
          commit('saveMessage', {
            user: user._id,
            text: `Autentificare reusita! Bine ai venit, ${user.username}!`,
            timestamp: new Date(),
            type: 'success',
            tip: 'auth'
          })
          commit('setUser', user)
          commit('setToken', token)
          dispatch('getInfo')
          dispatch('entities/fetchEntities')

          // if (state.autoRefresh) {
          //   dispatch('entities/refreshAllEntities')
          // }

          dispatch('entities/setupWorker')

          setTimeout(() => {
            dispatch('check4AdminRequests')
          }, 5 * 1000)
          commit('setNetworkBusy', false)
          return Promise.resolve(user)
        } catch (error) {
          console.log(error)
          dispatch('logout')
          commit('addMessage', {
            _id: uniqid(),
            text: error.name === 'NotAuthenticated' ? 'Autentificare esuata. Date invalide...' : error.message,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error',
            local: true
          })
          commit('setNetworkBusy', false)
          return Promise.reject(new Error('Nope. Date invalide, bro!'))
        }
      } else {
        try {
          let token = await state.feathers.passport.getJWT()
          if (token) {
            const auth = await state.feathers.authenticate()

            const user = auth.user
            token = auth.accessToken

            await state.feathers.passport.verifyJWT(auth.accessToken)

            dispatch('setEventWatchers')
            commit('saveMessage', {
              user: user._id,
              text: `Autentificare reusita! Bine ai venit, ${user.username}!`,
              timestamp: new Date(),
              type: 'success',
              tip: 'auth'
            })
            commit('setUser', user)
            commit('setToken', token)
            dispatch('getInfo')
            dispatch('entities/fetchEntities')

            // if (state.autoRefresh) {
            //   dispatch('entities/refreshAllEntities')
            // }

            dispatch('entities/setupWorker')

            setTimeout(() => {
              dispatch('check4AdminRequests')
            }, 5 * 1000)
            commit('setNetworkBusy', false)
            return Promise.resolve(user)
          } else {
            commit('setNetworkBusy', false)
            return Promise.reject(new Error('No token found. Use the Login form.'))
          }
        } catch (err) {
          commit('setNetworkBusy', false)
          return Promise.reject(new Error('No token found. Use the Login form.'))
        }
      }
    },
    async logout ({ state, commit }) {
      if (state.auth.user) {
        commit('resetLog')
      }

      await feathersClient.logout()
      commit('setToken', null)
      commit('setUser', null)
    },

    async checkAutoRefresh ({ state, commit, dispatch }) {
      if (state.autoRefresh) {
        dispatch('entities/fetchEntities')
        dispatch('entities/setActiveEntity')
        dispatch('entities/refreshAllEntities')
      } else {
        commit('entities/setDbFresh', false, { root: true })
      }
    },

    setEventWatchers ({ state, commit, dispatch }) {
      state.services.entities.events.forEach(event => {
        state.services.entities.on(event, debounce(data => {
          commit('incrementRefreshCount')
          // commit setDbFresh from entities module

          dispatch('checkAutoRefresh')
        }, 5000))
      })

      state.services.adminrequests.on('created', debounce(data => {
        if (data.user_id === state.auth.user._id) {
          dispatch('sendAdminResponse', { _id: data._id })
        }
      }, 5000))

      state.services.adminrequests.on('patched', debounce(data => {
        if (state.auth.user.admin) {
          dispatch('fetchAdminRequests', { _id: data.user_id })
        }
      }, 5000))
    },

    // adds to the locations collection
    async saveUserLocation ({ state, commit, dispatch }, payload) {
      if (state.auth.user) {
        const location = {
          user_id: state.auth.user._id,
          lat: payload.coords.latitude,
          lng: payload.coords.longitude,
          accuracy: payload.coords.accuracy
        }

        try {
          const lastPosition = state.auth.user.currentPosition
          const currentPosition = { lat: payload.coords.latitude, lng: payload.coords.longitude }

          if (lastPosition) {
            // only save it distance between positions is greater than threshold
            const dist = distance(lastPosition.lat, lastPosition.lng, currentPosition.lat, currentPosition.lng)

            if (dist > 10) {
              await state.services.locations.create(location)
            }
          } else {
            await state.services.locations.create(location)
          }
        } catch (err) {
          console.log(err)
        }
      }
    },

    // gets location days for a given user b y setting the $uniqueDays query param to true and sending the user_id
    async getUserLocationDays ({ state }, payload) {
      if (state.auth.user) {
        try {
          const query = {
            user_id: payload.user_id,
            $uniqueDays: true
          }

          const days = await state.services.locations.find({ query })

          return days
        } catch (err) {
          console.log(err)
        }
      }
    },

    // gets locations for a given day
    async getUserLocations ({ state, commit, dispatch }, payload) {
      if (state.auth.user) {
        try {
          // payload day contains ISO date string
          // filter createdAt to be between payload.day 00:00:00 and 23:59:59

          const [y, m, d] = payload.day.split('-')

          const createdAt = {
            $gte: new Date(Date.UTC(y, m - 1, d, 0, 0, 0)),
            $lte: new Date(Date.UTC(y, m - 1, d, 23, 59, 59))
          }

          const query = {
            user_id: payload.user_id,
            createdAt,
            $sort: {
              createdAt: -1
            },
            $paginate: false
          }

          if (payload.accuracy) {
            query.accuracy = { $lt: payload.accuracyValue }
          }

          const locations = await state.services.locations.find({ query })

          return locations
        } catch (err) {
          console.log(err)

          return []
        }
      }
    },

    setupPositionWatcher ({ state, commit, dispatch }) {
      if (navigator.geolocation) {
        dispatch('getLocation')

        dispatch('stopPositionWatcher')
        const watchId = setInterval(() => {
          dispatch('getLocation')
        }, 1000 * 60 * 5)

        commit('setWatchId', watchId)
        commit('setWatchingPosition', true)
      }
    },

    stopPositionWatcher ({ state, commit }) {
      if (state.watchId) {
        clearTimeout(state.watchId)
        commit('setWatchId', null)
        commit('setWatchingPosition', false)
      }
    },

    async getLocation ({ state, commit, dispatch }) {
      commit('setNetworkBusy', true)
      if (navigator.geolocation) {
        try {
          commit('setGettingPosition', true)
          const position = await getPositionAPI({
            enableHighAccuracy: false,
            timeout: 5000,
            maximumAge: 10000
          })

          if (position.coords && position.coords.latitude) {
            dispatch('saveUserLocation', position)

            commit('setCurrentPosition', { lat: position.coords.latitude, lng: position.coords.longitude })
            // commit('setMapCenter', { lat: position.coords.latitude, lng: position.coords.longitude })

            await state.services.users.patch(state.auth.user._id, {
              currentPosition: { lat: position.coords.latitude, lng: position.coords.longitude }
              // lastMapCenter: { lat: position.coords.latitude, lng: position.coords.longitude }
            })
          }
          commit('setGettingPosition', false)
        } catch (err) {
          if (err.code === 1) {
            alert('Pentru ca aplicatia sa functioneze in conditii optime, va rugam sa permiteti accesul la pozitia d-voastra geografica!')
          } else if (err.code === 2) {
            alert('Sistemul d-voastra a raportat o eroare la incercarea de a gasi coordonatele d-voastra.')
          }
          commit('setGettingPosition', false)
        }
      }
      commit('setNetworkBusy', false)
    },
    setOnlineOfflineHandler ({ state, commit }) {
      if (!state.windowEvents) {
        window.addEventListener('online', handleConnection)
        window.addEventListener('offline', handleConnection)
        commit('setWindowEventsState', true)
      } else {
        handleConnection()
      }

      function handleConnection () {
        // console.log('netwrok state changed')
        if (navigator.onLine) {
          isReachable(window.location.origin).then(online => {
            if (online) {
              commit('setOnline', 'on')
              // console.log('online')
            } else {
              commit('setOnline', 'lie-fi')
              // console.log('no connectivity')
            }
          })
        } else {
          commit('setOnline', 'off')
          // console.log('offline')
        }
      }

      function isReachable (url) {
        /**
         * Note: fetch() still "succeeds" for 404s on subdirectories,
         * which is ok when only testing for domain reachability.
         *
         * Example:
         *   https://google.com/noexist does not throw
         *   https://noexist.com/noexist does throw
         */

        const controller = new AbortController()
        const signal = controller.signal

        const timeoutId = setTimeout(() => controller.abort(), 5000)

        return fetch(url, { method: 'HEAD', mode: 'no-cors', signal })
          .then(resp => {
            clearTimeout(timeoutId)
            return resp && (resp.ok || resp.type === 'opaque')
          })
          .catch(err => {
            clearTimeout(timeoutId)
            console.warn('[conn test failure]:', err)
          })
      }

      handleConnection()
      setInterval(handleConnection, 60 * 1000)
    },
    async setMapCenter ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        await state.services.users.patch(state.auth.user._id, {
          lastMapCenter: payload
        })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },
    async setZoom ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        await state.services.users.patch(state.auth.user._id, {
          zoom: payload
        })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },
    async setMapType ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        await state.services.users.patch(state.auth.user._id, {
          mapType: payload
        })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },
    async getInfo ({ state, commit }) {
      commit('setNetworkBusy', true)
      try {
        const result = await fetch(`${state.serverURL}/rest-getInfo`, {
          headers: new Headers({
            'Authorization': state.auth.token
          })
        })
        if (result.ok) {
          const data = await result.json()
          commit('setInfo', data)
        }
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },
    async getStats ({ state, commit }) {
      commit('setNetworkBusy', true)
      try {
        const stats = {
          users: []
        }
        stats.users = await state.services.users.find({ query: { $paginate: false, $select: [ 'username', 'avatar' ], admin: false } })

        for (let user of stats.users) {
          user.photos = (await state.services.photos.find({
            query: {
              user: user._id,
              $limit: 0
            }
          })).total

          const userStats = await fetch(
            `${state.serverURL}/rest-getStats?user=${user._id}`,
            {
              headers: new Headers({
                'Authorization': state.auth.token
              })
            }
          )

          const userStatsJson = await userStats.json()

          user.simboluri = userStatsJson.entityCount[0] ? userStatsJson.entityCount[0].total : 0
          // user.etichete = userStatsJson.labelCount
        }
        commit('setStats', stats)
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },

    async setZoomDetailsPage ({ state, commit }, payload) {
      try {
        await state.services.users.patch(state.auth.user._id, {
          lastMapCenterDetailsPage: payload
        })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },
    async setMapTypeDetailsPage ({ state, commit }, payload) {
      try {
        await state.services.users.patch(state.auth.user._id, {
          mapTypeDetailsPage: payload
        })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },

    async fetchUsers ({ state, commit }) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)
        if (state.auth.user.admin) {
          const users = await state.services.users.find({ query: { $paginate: false } })
          commit('setUsers', users)
        } else {
          commit('setUsers', [{ _id: state.auth.user._id, color: state.auth.user.color, username: state.auth.user.username }])
        }
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    },
    async addUser ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)
        await state.services.users.create(payload)
        this.dispatch('fetchUsers')
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    },
    async removeUser ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)
        await state.services.users.remove(payload)
        this.dispatch('fetchUsers')
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    },

    async patchUser ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)
        await state.services.users.patch(payload.id, payload.data)
        this.dispatch('fetchUsers')
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    },

    async fetchAllUserLocations ({ state, commit }) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)
        const users = await state.services.users.find({ query: { $paginate: false } })
        commit('setUsersLocations', users)
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    },

    async fetchAdminRequests ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        if (payload._id) {
          const data = await state.services.adminrequests.find({
            query: {
              user_id: payload._id,
              $sort: {
                createdAt: -1
              },
              $limit: state.expandedPagination.rowsPerPage,
              $skip: (state.expandedPagination.page - 1) * state.expandedPagination.rowsPerPage
            }
          })

          commit('setAdminRequestsData', data)
        }
        commit('setNetworkBusy', false)
        return true
      } catch (err) {
        console.log(err)
        commit('setNetworkBusy', false)
      }
    },

    async sendAdminRequest ({ state, commit, dispatch }, payload) {
      commit('setNetworkBusy', true)
      try {
        await state.services.adminrequests.create({
          user_id: payload._id,
          type: 'pending photos'
        })

        dispatch('fetchAdminRequests', { _id: payload._id })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },
    async sendAdminResponse ({ state, commit, getters }, payload) {
      commit('setNetworkBusy', true)
      try {
        const files = getters['entities/files']

        await state.services.adminrequests.patch(payload._id, { response: { files } })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },

    async check4AdminRequests ({ state, commit, dispatch }) {
      commit('setNetworkBusy', true)
      try {
        const data = await state.services.adminrequests.find({
          query: {
            user_id: state.auth.user._id,
            response: {
              $exists: false
            },
            $sort: {
              createdAt: -1
            },
            $limit: 1
          }
        })

        if (data && data.data && data.data.length) {
          const request = data.data[0]

          dispatch('sendAdminResponse', request)
        }
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },

    async deleteAdminRequest ({ state, commit, dispatch }, payload) {
      commit('setNetworkBusy', true)
      try {
        await state.services.adminrequests.remove(payload.id)
        dispatch('fetchAdminRequests', { _id: payload.user_id })
      } catch (err) {
        console.log(err)
      }
      commit('setNetworkBusy', false)
    },

    setDiffPagination ({ commit, dispatch }, payload) {
      commit('setDiffPagination', payload)
      // this gets triggered before the component is mounted
      dispatch('fetchDiff')
    },

    setDiffEntity ({ commit, dispatch }, payload) {
      commit('setDiffEntity', payload)
      dispatch('fetchDiff')
    },
    setDiffUser ({ commit, dispatch }, payload) {
      commit('setDiffUser', payload)
      dispatch('fetchDiff')
    },
    setDiffOperations ({ commit, dispatch }, payload) {
      commit('setDiffOperations', payload)
      dispatch('fetchDiff')
    },

    fetchDiff: debounce(async function ({ state, commit }) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)

        const query = {
          $limit: state.diffPagination.rowsPerPage,
          $skip: state.diffPagination.rowsPerPage * (state.diffPagination.page - 1),
          $sort: {
            'createdAt': -1
          }
        }

        if (state.diffOperations && state.diffOperations.length) {
          query.operation = {
            $in: state.diffOperations
          }
        }

        if (state.diffUser && state.diffUser.length) {
          query.user = {
            $in: state.diffUser
          }
        }

        if (state.diffEntity) {
          query.id_scara = state.diffEntity
        }

        const diff = await state.services.diff.find({
          query
        })
        commit('setDiff', diff)
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    }, 1000),

    async saveReminder ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)
        await state.services.reminders.create(payload)
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    },
    fetchReminders: debounce(async function ({ state, commit }, payload) {
      commit('setNetworkBusy', true)
      try {
        commit('setLoading', true)

        const date = new Date(payload.date)
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)

        const query = {
          $paginate: false,
          $populate: [
            {
              path: 'user_id',
              select: 'username'
            },
            {
              path: 'entity_id',
              select: 'id_scara'
            }
          ],
          start_date: {
            $gte: firstDay,
            $lte: lastDay
          },
          $sort: {
            staret_date: 1
          }
        }

        if (payload.entity) {
          // console.log('for entity', payload.entity)
          query.entity_id = payload.entity
        }

        if (!state.auth.user.admin) {
          query.user_id = state.auth.user._id
        }

        const reminders = await state.services.reminders.find({
          query
        })
        commit('setReminders', reminders)
        commit('setLoading', false)
      } catch (err) {
        console.log(err)
        commit('setLoading', false)
      }
      commit('setNetworkBusy', false)
    }, 1000),

    deleteReminder ({ state }, payload) {
      return state.services.reminders.remove(payload._id)
    },
    toggleReminderDone ({ state }, payload) {
      return state.services.reminders.patch(payload._id, { is_done: payload.done })
    }
  }
})

function decodeLocalStorage (name, type = 'array') {
  try {
    const item = localStorage.getItem(name)
    const decoded = item ? JSON.parse(item) : (type === 'array' ? [] : {})

    if (type === 'array') {
      if (!Array.isArray(decoded)) {
        return [decoded]
      } else {
        return decoded
      }
    } else {
      return decoded
    }
  } catch (err) {
    const item = localStorage.getItem(name)

    if (item) {
      if (type === 'array') {
        return [item]
      } else {
        return { item }
      }
    } else {
      return type === 'array' ? [] : {}
    }
  }
}

function getPositionAPI (options) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
}

function distance (lat1, lng1, lat2, lng2) {
  const R = 6371e3 // Earth's radius in meters
  const φ1 = toRadians(lat1)
  const φ2 = toRadians(lat2)
  const Δφ = toRadians(lat2 - lat1)
  const Δλ = toRadians(lng2 - lng1)

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c

  return d
}

function toRadians (degrees) {
  return degrees * Math.PI / 180
}
